<template>
  <div class="cameraBtn" :style="{ width: w / 37.5 + 'rem' }">
    <div class="camera-icon"></div>
    {{ btnText }}
  </div>
</template>

<script>
export default {
  props: {
    btnText: {
      type: String,
      default: '拍名片快速报名'
    },
    w: {
      type: Number,
      default: 250
    }
  },
  name: 'cameraBtn'
}
</script>

<style scoped lang="less">
  @import "../less/variable";
  .cameraBtn {
    position: relative;
    cursor: pointer;
    margin-top: 10px;
    .w(@businessCardWidth);
    .h(40);
    .lh(40);
    color: #fff;
    .fs(16);
    background-color: @mainRed;
    .camera-icon {
      position: absolute;
      .left(8);
      top: 50%;
      transform: translateY(-50%);
      .w(30);
      .h(30);
      background: url("../images/camera-btn.png") no-repeat center center / contain;
      box-shadow: 2px 2px 2px 2px rgba(181, 56, 72, 0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cameraBtn.vue